// table-columns
import i18n from '@/lang';

export const columns = [
  // 客户ID
  // { prop: 'customerId', label: i18n.t('basicData.CustomerID'), width: 120, align: 'left' },
  // cnpj
  { prop: 'cnpj', label: 'CNPJ', width: 180, align: 'left' },
  // 客户名称
  { prop: 'customerName', label: i18n.t('basicData.CustomerName'), width: 180, align: 'left' },
  // 收款账号
  {
    prop: 'bankAccountName',
    label: i18n.t('basicData.ReceivingAccount'),
    width: 180,
    align: 'left'
  },
  // 交易日期
  { prop: 'tradeDate', label: i18n.t('basicData.TransactionDate'), width: 180, align: 'left' },
  // 交易类型
  { prop: 'tradeTypeDesc', label: i18n.t('basicData.TransactionType'), width: 180, align: 'left' },
  // 流水号
  { prop: 'rechargeNo', label: i18n.t('basicData.SerialNumber'), width: 180, align: 'left' },
  // 交易金额
  { prop: 'amount', label: i18n.t('basicData.TransactionAmount'), width: 180, align: 'left' },
  // 交易方式
  {
    prop: 'payMethodDesc',
    label: i18n.t('basicData.TransactionMethod'),
    width: 180,
    align: 'left'
  },
  // 交易状态
  { prop: 'statusDesc', label: i18n.t('basicData.TransactionStatus'), width: 180, align: 'left' },
  // 交易失败原因
  {
    prop: 'tradeFailReason',
    label: i18n.t('basicData.TransactionFailureReason'),
    width: 200,
    align: 'left'
  },
  // 交易人
  { prop: 'traderName', label: i18n.t('basicData.Transactor'), width: 140, align: 'left' },
  // 资金核对状态
  {
    prop: 'fundCheckStatusDesc',
    label: i18n.t('basicData.FundStatusVerification'),
    width: 140,
    align: 'left'
  },
  // 核对人
  { prop: 'reviewerName', label: i18n.t('basicData.Verifier'), width: 140, align: 'left' },
  // 附件
  { prop: 'receiptUrl', label: i18n.t('basicData.annex'), width: 160, align: 'left' }
];

// 交易类型
export const TRANSACTION_TYPE = [
  {
    value: 1,
    label: i18n.t('customerManagements.Recharge')
  },
  {
    value: 2,
    label: i18n.t('basicData.Refund')
  }
];

// 交易状态
export const TRANSACTION_STATUS = [
  {
    value: 0,
    label: i18n.t('basicData.PendingConfirmation')
  },
  {
    value: 1,
    label: i18n.t('basicData.PaymentInProgress')
  },
  {
    value: 2,
    label: i18n.t('basicData.Paid')
  },
  {
    value: 3,
    label: i18n.t('basicData.PaymentFailed')
  },
  {
    value: 4,
    label: i18n.t('basicData.Closed')
  },
  {
    value: 5,
    label: i18n.t('basicData.RefundInProgress')
  },
  {
    value: 6,
    label: i18n.t('basicData.Refunded')
  },
  {
    value: 7,
    label: i18n.t('basicData.RefundFailed')
  }
];

// 资金核对状态
export const FUNDSTATUSVERIFICATION = [
  {
    value: 0,
    label: i18n.t('basicData.PendingConfirmation')
  },
  {
    value: 1,
    label: i18n.t('basicData.Received')
  },
  {
    value: 2,
    label: i18n.t('basicData.Exception')
  }
];

export const formRule = {
  // CNPJ 校验——必填 + 14位数字+字母
  cnpj: [
    {
      required: true,
      message: i18n.t('basicData.CannotBeEmpty'),
      trigger: ['blur', 'change']
    },
    {
      pattern: /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/,
      message: i18n.t('basicData.formatError'),
      trigger: ['blur', 'change']
    }
  ],
  // 客户ID校验——必填
  customerId: [
    {
      required: true,
      message: i18n.t('basicData.CannotBeEmpty'),
      trigger: ['blur', 'change']
    }
  ],
  // 充值金额校验——必填 + 大于0
  amount: [
    {
      required: true,
      message: i18n.t('basicData.CannotBeEmpty'),
      trigger: ['blur', 'change']
    },
    {
      pattern: /^(0(\.\d{1,2})?|[1-9]\d*(\.\d{1,2})?)$/,
      message: i18n.t('basicData.NumericWithTwoDecimals'),
      trigger: ['blur', 'change']
    }
  ],
  // 充值日期校验——必填
  rechargeDate: [
    {
      required: true,
      message: i18n.t('basicData.CannotBeEmpty'),
      trigger: 'change'
    }
  ],
  // 流水号校验——必填
  serialNumber: [
    {
      required: true,
      message: i18n.t('basicData.CannotBeEmpty'),
      trigger: ['blur', 'change']
    }
  ],
  // 收款账号校验——必填
  bankAccountId: [
    {
      required: true,
      message: i18n.t('basicData.CannotBeEmpty'),
      trigger: 'change'
    }
  ]
};
